var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuoteExpiry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49815",
    "data-name": "Group 49815",
    transform: "translate(-1214 -661)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19350",
    "data-name": "Rectangle 19350",
    width: 40,
    height: 40,
    transform: "translate(1214 661)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49814",
    "data-name": "Group 49814",
    transform: "translate(15389.062 11711.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M53.082,56.589l-4.456-7.5h0l-1.285-2.164a1.153,1.153,0,0,0-1.982,0l-5.745,9.662a1.157,1.157,0,0,0,.993,1.743H52.09a1.153,1.153,0,0,0,.993-1.743Zm-6.734.154a.7.7,0,1,1,.714-.714.714.714,0,0,1-.714.707Zm.886-5.981-.264,3.078a.621.621,0,0,1-1.239,0l-.264-3.078a1.071,1.071,0,0,1,.254-.811.828.828,0,0,1,1.246,0,1.071,1.071,0,0,1,.268.8Z",
    transform: "translate(-14198.278 -11077.994)",
    fill: "#527e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M33.184,29.5a2.192,2.192,0,0,1,3.774,0l.75,1.264a8.1,8.1,0,1,0-8.548,5.517Zm-5.528,1.607a.5.5,0,0,1-.357-.154.518.518,0,0,1,0-.736l2.207-2.207V23.881a.521.521,0,0,1,1.043,0V28.23a.521.521,0,0,1-.154.357l-2.382,2.371a.518.518,0,0,1-.357.154Z",
    transform: "translate(-14187 -11061.127)",
    fill: "#527e3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteExpiry);
export default __webpack_public_path__ + "static/media/Quote Expiry.c195dec6e8917c5b3319a0df5cf23b33.svg";
export { ForwardRef as ReactComponent };